import React, {useRef, useState} from "react";

function FileBase64({ multiple = false, onDone, accept }) {
  const inputRef = useRef(null);
  const [fileNames, setFileNames] = useState([]);

  const handleChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setFileNames(files.map((f) => f.name));

    const readers = files.map(
      (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve({
              base64: reader.result,
              name: file.name,
              size: file.size,
              type: file.type,
            });
          };
          reader.readAsDataURL(file);
        })
    );

    Promise.all(readers).then((results) => {
      if (onDone) {
        onDone(multiple ? results : results[0]);
      }
    });

    // Limpa o input para permitir selecionar o mesmo arquivo novamente
    e.target.value = "";
  };

  const label =
    fileNames.length === 0
      ? "Nenhum arquivo selecionado"
      : fileNames.length === 1
        ? fileNames[0]
        : `${fileNames.length} arquivos selecionados`;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={handleChange}
        style={{ display: "none" }}
      />
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={() => inputRef.current.click()}
      >
        Escolher arquivo{multiple ? "s" : ""}
      </button>
      <span
        style={{
          fontSize: "0.875rem",
          color: fileNames.length > 0 ? "#212529" : "#6c757d",
          maxWidth: "300px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={fileNames.join(", ")}
      >
        {label}
      </span>
    </div>
  );
}

export default FileBase64;
